import { render, staticRenderFns } from "./LandedCostComponentForm.vue?vue&type=template&id=9b8b1376"
import script from "./LandedCostComponentForm.vue?vue&type=script&lang=js"
export * from "./LandedCostComponentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports